import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext, useRef, } from "react";
import { useAccount } from "wagmi";
import { useAuth } from "../auth";
import { useSupportedChains } from "../chain";
const SwapModalContext = createContext(null);
export const useSwapModalContext = () => {
    const context = useContext(SwapModalContext);
    if (!context) {
        throw new Error("useSwapModalContext must be used within a SwapModalProvider");
    }
    return context;
};
export const SwapModalProvider = ({ children, }) => {
    var _a;
    const swapModalRef = useRef();
    const { authenticated, walletAddress } = useAuth();
    const account = useAccount();
    const walletChainId = (_a = account === null || account === void 0 ? void 0 : account.chain) === null || _a === void 0 ? void 0 : _a.id;
    const supportedChainsHook = useSupportedChains(!walletAddress || !authenticated || !walletChainId);
    return (_jsx(SwapModalContext.Provider, { value: {
            swapModalRef,
            ...supportedChainsHook,
        }, children: children }));
};
